// Module: reports — «التقارير» (HANDOFF §3 `/reports/*`, §5.7; flag
// erp.reports; manager+ — HANDOFF §9 «reports» is not for staff; the server
// enforces with auth.RequireRole(manager) on every report route).
//
// Built: the five boards that exist — pnl, cashflow, staff-revenue,
// trial-balance, balance-sheet. HANDOFF §3 also lists «الشهر», «حركة
// الصناديق» and «مصدر الحجز»; no board draws them, so they are absent (rule 6
// / BRIEF rule 13 — never a placeholder row). «إيراد الفريق» additionally
// needs erp.team (the shares come from the team module).
//
// Routes are absolute (/reports/<name>); /reports lands on «أرباح وخسائر».
// URL state: ?r=<chip id> (period chip), ?cmp=1 (P&L comparison figures in
// the KPI cells), ?branch_id=<uuid> (branch scope, passed to the API).

import { ChartColumn } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { defineModule, gate } from '@/app/module-types';

export default defineModule({
  key: 'reports',
  label: 'التقارير',
  icon: ChartColumn,
  flag: 'erp.reports',
  minRole: 'manager',
  rail: 'reports',
  routes: [
    { path: '/reports', element: <Navigate to="/reports/pnl" replace /> },
    { path: '/reports/pnl', lazy: () => import('./screens/PnL').then((m) => ({ Component: m.PnlRoute })), handle: gate({ minRole: 'manager' }) },
    { path: '/reports/cashflow', lazy: () => import('./screens/CashFlow').then((m) => ({ Component: m.CashFlowRoute })), handle: gate({ minRole: 'manager' }) },
    {
      path: '/reports/trial-balance',
      lazy: () => import('./screens/TrialBalance').then((m) => ({ Component: m.TrialBalanceRoute })),
      handle: gate({ minRole: 'manager' }),
    },
    {
      path: '/reports/balance-sheet',
      lazy: () => import('./screens/BalanceSheet').then((m) => ({ Component: m.BalanceSheetRoute })),
      handle: gate({ minRole: 'manager' }),
    },
    {
      path: '/reports/staff-revenue',
      lazy: () => import('./screens/StaffRevenue').then((m) => ({ Component: m.StaffRevenueRoute })),
      handle: gate({ minRole: 'manager', flag: 'erp.team' }),
    },
  ],
  menu: [
    { key: 'pnl', label: 'أرباح وخسائر', to: '/reports/pnl' },
    { key: 'cashflow', label: 'التدفق النقدي', to: '/reports/cashflow' },
    { key: 'trial-balance', label: 'ميزان المراجعة', to: '/reports/trial-balance' },
    { key: 'balance-sheet', label: 'الميزانية العمومية', to: '/reports/balance-sheet' },
    // Sector wording on the screen title; the menu row keeps the board
    // eyebrow's neutral name until a staff-member terminology token exists.
    { key: 'staff-revenue', label: 'إيراد الفريق', to: '/reports/staff-revenue', flag: 'erp.team' },
  ],
});
